import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";



export function useStockAdjustmentApi() {
  const callApi = useApiCall();
  

  const getStockAdjustmentList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.STOCK_ADJUSTMENT.LIST, data, onSuccess, onError);
  };
  const saveStockAdjustment = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.STOCK_ADJUSTMENT.SAVE, data, onSuccess, onError);
  };
  const deleteStockAdjustment = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.STOCK_ADJUSTMENT.DELETE, data, onSuccess, onError);
  };
  const getStockAdjustmentCode = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.STOCK_ADJUSTMENT.GET_ID, data, onSuccess, onError);
  };
  const getStockAdjustmentByID = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.STOCK_ADJUSTMENT.GET_BY_ID, data, onSuccess, onError);
  };
  const Exportcsv = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.STOCK_ADJUSTMENT.EXPORT_TO_XLS, data, onSuccess, onError);
  };
  const GetStockTransactionReport = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.STOCK_ADJUSTMENT.GET_STOCK_TRANSACTION_REPORT, data, onSuccess, onError);
  };
  const ExportStockTransactionReportcsv = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.STOCK_ADJUSTMENT.EXPORT_STOCK_TRANSACTION_REPORT_XLS, data, onSuccess, onError);
  };
  const getStockAdjustmentReport = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.STOCK_ADJUSTMENT.GET_STOCK_ADJUSTMENT_REPORT, data, onSuccess, onError);
  };
  const ExportStockAdjustmentReportXls = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.STOCK_ADJUSTMENT.EXPORT_STOCK_ADJUSTMENT_REPORT_XLS, data, onSuccess, onError);
  };
  const ExportStockAdjustmentReportPdf = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.STOCK_ADJUSTMENT.EXPORT_STOCK_ADJUSTMENT_REPORT_PDF, data, onSuccess, onError);
  };

  return {
    getStockAdjustmentList,
    saveStockAdjustment,
    deleteStockAdjustment,
    getStockAdjustmentCode,
    getStockAdjustmentByID,
    Exportcsv,
    GetStockTransactionReport,
    ExportStockTransactionReportcsv,
    getStockAdjustmentReport,
    ExportStockAdjustmentReportXls,
    ExportStockAdjustmentReportPdf,
  };
}
